// src/pages/Blog.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { wp } from "../lib/wp";

const BRAND = "#403f95";

// Öne çıkarılan görseli seç (akıllı fallback)
const getFeatured = (post) => {
  const media =
    post?._embedded?.["wp:featuredmedia"]?.[0] ||
    post?._embedded?.featuredmedia?.[0];
  return (
    media?.media_details?.sizes?.medium_large?.source_url ||
    media?.media_details?.sizes?.medium?.source_url ||
    media?.media_details?.sizes?.thumbnail?.source_url ||
    media?.source_url ||
    null
  );
};

// HTML'i kısa metne indir (excerpt için)
const toPlain = (html) =>
  (html || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // ÖNEMLİ: _embed=1 ekli
    fetch(wp("/wp/v2/posts?_embed=1"))
      .then((r) => r.json())
      .then((data) => setPosts(Array.isArray(data) ? data : []))
      .catch(() => setPosts([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="bg-[#f9f9f6] min-h-screen py-12 px-4">
      <div className="max-w-5xl mx-auto">
        {/* Başlık */}
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold mb-2" style={{ color: BRAND }}>
            BLOG
          </h2>
          <p className="text-gray-600 text-sm">
            Demiray Mimarlık’tan haberler, fikirler ve ilhamlar
          </p>
        </div>

        {/* Liste */}
        {loading ? (
          <div>Yükleniyor…</div>
        ) : posts.length === 0 ? (
          <div>Henüz içerik yok.</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {posts.map((post) => {
              const img = getFeatured(post);
              const titleHtml = post.title?.rendered || "Başlıksız";
              const excerpt = toPlain(post.excerpt?.rendered).slice(0, 160);

              return (
                <article
                  key={post.id}
                  className={[
                    "group relative bg-white rounded-xl p-4",
                    "border",
                    "transition-all duration-300 ease-out",
                    "shadow-[0_10px_25px_rgba(39,40,92,0.20),0_2px_6px_rgba(39,40,92,0.12)]",
                    "hover:shadow-[0_24px_60px_rgba(39,40,92,0.35),0_6px_14px_rgba(39,40,92,0.22)]",
                  ].join(" ")}
                  style={{ borderColor: BRAND }}
                >
                  <Link to={`/blog/${post.slug}`} className="flex gap-4">
                    {/* Görsel */}
                    <div className="w-32 sm:w-40 md:w-36 lg:w-40 overflow-hidden rounded-lg flex-shrink-0">
                      {img ? (
                        <img
                          src={img}
                          alt={toPlain(titleHtml)}
                          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-[1.03]"
                          loading="lazy"
                        />
                      ) : (
                        <div className="w-full h-full bg-gray-200" />
                      )}
                    </div>

                    {/* Metin */}
                    <div className="flex-1 min-w-0">
                      <h3
                        className="text-lg font-semibold text-gray-800 leading-snug line-clamp-2"
                        dangerouslySetInnerHTML={{ __html: titleHtml }}
                      />
                      <p className="mt-2 text-sm text-gray-600 line-clamp-3">
                        {excerpt}
                      </p>

                      <span
                        className="mt-3 inline-block text-sm font-medium relative text-[#424197]
                                   after:content-[''] after:absolute after:left-0 after:-bottom-0.5
                                   after:h-[2px] after:w-0 after:bg-[#424197]
                                   after:transition-all after:duration-500 group-hover:after:w-full"
                      >
                        Devamını oku →
                      </span>
                    </div>
                  </Link>

                  {/* Zemine düşen oval gölge */}
                  <div
                    className="pointer-events-none absolute inset-x-10 -bottom-3 h-6 rounded-full blur-xl opacity-50 group-hover:opacity-90 transition-opacity"
                    style={{ backgroundColor: "rgba(91,95,131,0.4)" }}
                  />
                </article>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default Blog;
